import React from "react";
import TransactionTable from "./list/TransactionList";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "../../components/common/css/datatable.scss";
import "../../components/common/css/index.scss";

const Transaction = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <TransactionTable />
      </div>
    </div>
  );
};

export default Transaction;
